function mapReviews(data) {
  const { reviews = [] } = data;
  const mReviews = reviews.map(
    ({
      orderId,
      userName,
      userAvatar,
      createdAt,
      userCommentary,
      pillRating,
    }) => ({
      id: orderId,
      description: userCommentary,
      registeredDate: createdAt,
      generalScore: pillRating,
      userName,
      userAvatar,
    }),
  );
  return {
    total: mReviews.length || 0,
    size: mReviews.length || 0,
    data: mReviews,
  };
}

export default mapReviews;
